var _style, _g, _path, _g2, _path2, _g3, _path3, _path4, _path5, _path6, _g4, _path7, _g5, _path8, _path9, _path10, _path11, _g6, _g7, _g8, _path12, _path13, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#061357;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:#F08299;}\r\n\t.st4{fill:url(#SVGID_1_);}\r\n\t.st5{fill:url(#SVGID_00000179606338345160437200000008119224113585008515_);}\r\n\t.st6{fill:#FFE02E;}\r\n\t.st7{fill:url(#SVGID_00000168097053547387278770000012536285090630152845_);}\r\n\t.st8{fill:url(#SVGID_00000178200998264944054880000010158385039766118298_);}\r\n\t.st9{fill:url(#SVGID_00000037681143568995019180000002792582075468095135_);}\r\n\t.st10{fill:url(#SVGID_00000019663000698083024830000005340094436721290916_);}\r\n\t.st11{fill:url(#SVGID_00000116938855674683843570000016137034558572043673_);}\r\n\t.st12{fill:url(#SVGID_00000054956634656595760860000006162907643538637214_);}\r\n\t.st13{fill:#F49A0B;}\r\n\t.st14{fill:url(#SVGID_00000085237001850021301410000008164660599436344242_);}\r\n\t.st15{opacity:0.4;fill:#CD2D2F;}\r\n\t.st16{fill:#93439C;}\r\n\t.st17{fill:url(#SVGID_00000175284253123204068840000008058899538901281469_);}\r\n\t.st18{fill:url(#SVGID_00000155133027974631861840000017823891711271419305_);}\r\n\t.st19{fill:url(#SVGID_00000109715171169981392990000004090180185902451636_);}\r\n\t.st20{fill:url(#SVGID_00000129175321923394092950000012621200376745115024_);}\r\n\t.st21{fill:url(#SVGID_00000039128112024853805360000010405975834122012070_);}\r\n\t.st22{fill:#5B0043;}\r\n\t.st23{fill:url(#SVGID_00000154394502407219471590000001705247053452510640_);}\r\n\t.st24{opacity:0.3;fill:#FEB46F;}\r\n\t.st25{opacity:0.4;fill:#5F0043;}\r\n\t.st26{fill:url(#SVGID_00000096756509831793688730000007555376598159758770_);}\r\n\t.st27{fill:url(#SVGID_00000055668523474679978720000001165983947525316794_);}\r\n\t.st28{fill:url(#SVGID_00000100380904769478001340000013859943834929729967_);}\r\n\t.st29{fill:#FFFFFF;}\r\n\t.st30{fill:#F39200;}\r\n\t.st31{fill:#007EAF;}\r\n\t.st32{opacity:0.4;fill:#F39200;}\r\n\t.st33{fill:#D60B52;}\r\n\t.st34{fill:#C20043;}\r\n\t.st35{fill:url(#SVGID_00000071550286378963419790000002087331624695645072_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -103,
    y: -57.94,
    className: "st1",
    width: 2126,
    height: 1195.88
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M898.58,1394.22c3.22,0,3.22-5,0-5C895.36,1389.22,895.36,1394.22,898.58,1394.22L898.58,1394.22z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M898.58,1407.36c3.22,0,3.22-5,0-5C895.36,1402.36,895.36,1407.36,898.58,1407.36L898.58,1407.36z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 482.3881,
    y1: 722.8885,
    x2: 482.3881,
    y2: 1055.1503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2732,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M917.6,1080.76c29.66-49.78,48.37-112.73,47.11-170.64c-1.1-50.7-15.73-102.69-49.53-140.5 c-9.21-10.3-19.78-19.52-27.37-31.07s-13.28-26.2-8.31-39.09h-25.28c2.85,12.03-0.82,24.87-7.32,35.39 c-6.5,10.52-15.63,19.11-24.69,27.53c-13.16,12.21-26.56,24.47-36.55,39.39c-10,14.92-16.41,33.02-13.91,50.8 c-16.47-4.15-35.93-0.08-45.76,13.77c-15.16-14.01-38.62-22.37-59.22-21.11c-20.6,1.26-40.53,11.23-53.88,26.98 c-14.16-6.94-33.34-7.28-47.53-0.41c-14.19,6.88-24.91,20.52-28.23,35.94c-8.34-11.95-22.01-20.44-36.48-22.18 c-14.47-1.74-29.59,2.97-40.52,12.61c-13.21-16.8-32.91-30.21-54.12-32.79c-21.21-2.57-43.35,3.58-60.19,16.73 c-2.09-17.02-10.95-32.48-24.72-42.69c-13.78-10.21-31.81-14.48-48.7-11.53c-4.73-22.03-20.5-43.67-39.73-55.41 c-19.24-11.73-43.34-15.18-65.09-9.32c-3-39.89-22.72-79.1-54.36-103.57C81.56,635.14,39.36,624.83,0,631.96v448.8H917.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026158484667281192650000004389502450301791149_",
    gradientUnits: "userSpaceOnUse",
    x1: 6927.2778,
    y1: 727.0534,
    x2: 6927.2778,
    y2: 1059.3152,
    gradientTransform: "matrix(-1 0 0 1 8364.8896 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2732,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026158484667281192650000004389502450301791149_)"
    },
    d: "M1920,1080.76V636.13 c-39.36-7.13-81.56,3.17-113.21,27.64c-31.65,24.47-51.36,63.68-54.36,103.57c-21.75-5.87-45.86-2.42-65.09,9.32 c-19.24,11.74-35,33.38-39.73,55.41c-16.89-2.95-34.92,1.32-48.7,11.53c-13.78,10.21-22.63,25.67-24.72,42.69 c-16.84-13.15-38.98-19.3-60.19-16.73c-21.21,2.57-40.91,15.99-54.12,32.79c-10.93-9.64-26.05-14.35-40.52-12.61 c-14.47,1.74-28.14,10.22-36.48,22.18c-3.32-15.41-14.04-29.06-28.23-35.94c-14.19-6.88-33.37-6.53-47.53,0.41 c-13.35-15.74-33.28-25.72-53.88-26.98c-20.6-1.26-44.06,7.11-59.22,21.11c-9.83-13.84-29.3-17.91-45.76-13.77 c2.5-17.78-3.92-35.89-13.91-50.8c-9.99-14.92-23.39-27.18-36.55-39.39c-9.06-8.41-18.19-17.01-24.69-27.53 c-6.5-10.52-10.17-23.36-7.32-35.39h-25.28c4.97,12.89-0.72,27.54-8.31,39.09s-18.16,20.77-27.37,31.07 c-33.8,37.81-48.43,89.8-49.53,140.5c-1.22,56.31,16.43,117.38,44.67,166.48H1920z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1386.44,
    cy: 984.52,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1134.13,
    cy: 908.32,
    r: 3.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1189.42,961.77c0,3.01-2.44,5.45-5.45,5.45c-3.01,0-5.45-2.44-5.45-5.45s2.44-5.45,5.45-5.45 C1186.98,956.32,1189.42,958.76,1189.42,961.77z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1107.75,
    cy: 869.93,
    r: 2.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1417.76,900.71c0,0.91-0.74,1.65-1.65,1.65c-0.91,0-1.65-0.74-1.65-1.65c0-0.91,0.74-1.65,1.65-1.65 C1417.03,899.06,1417.76,899.8,1417.76,900.71z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1121.08,
    cy: 879.27,
    r: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1193.59,887.87c0,2.66-2.15,4.81-4.81,4.81s-4.81-2.15-4.81-4.81c0-2.66,2.15-4.81,4.81-4.81 S1193.59,885.22,1193.59,887.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1414.47,978.28c0,2.25-1.83,4.08-4.08,4.08c-2.25,0-4.08-1.83-4.08-4.08s1.83-4.08,4.08-4.08 C1412.64,974.2,1414.47,976.03,1414.47,978.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 533.56,
    cy: 984.52,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 785.87,
    cy: 908.32,
    r: 3.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M730.58,961.77c0,3.01,2.44,5.45,5.45,5.45s5.45-2.44,5.45-5.45s-2.44-5.45-5.45-5.45 S730.58,958.76,730.58,961.77z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 812.25,
    cy: 869.93,
    r: 2.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M502.24,900.71c0,0.91,0.74,1.65,1.65,1.65c0.91,0,1.65-0.74,1.65-1.65c0-0.91-0.74-1.65-1.65-1.65 C502.98,899.06,502.24,899.8,502.24,900.71z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 798.92,
    cy: 879.27,
    r: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M726.41,887.87c0,2.66,2.15,4.81,4.81,4.81c2.66,0,4.81-2.15,4.81-4.81c0-2.66-2.15-4.81-4.81-4.81 C728.56,883.06,726.41,885.22,726.41,887.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M505.53,978.28c0,2.25,1.83,4.08,4.08,4.08s4.08-1.83,4.08-4.08s-1.83-4.08-4.08-4.08 S505.53,976.03,505.53,978.28z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145740951815691286830000010631145103423553717_",
    gradientUnits: "userSpaceOnUse",
    x1: 7404.8896,
    y1: 956.6606,
    x2: 7404.8896,
    y2: 1234.9579,
    gradientTransform: "matrix(-1 0 0 1 8364.8896 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145740951815691286830000010631145103423553717_)"
    },
    d: "M1920,1080.76V880.25 c-15.91-9.39-36.71-9.87-53.04-1.23c-16.33,8.64-28.86,25.63-30.04,44.07c-33.15-13.78-71.66-14.14-105.07-0.99 c-33.41,13.15-63.78,43.01-78.65,75.69c-20.35-5.48-44.52,7.65-51.37,27.58c-20.61-17.37-50.11-23.56-75.97-15.95 c-25.86,7.61-48.31,31.8-56.23,57.56c-4.3-6.06-11.52-9.95-18.95-10.19c-7.43-0.25-14.48,1.18-19.17,6.94 c-20.31-31.6-53.51-54.64-90.22-62.62c-36.71-7.98-75.95,6.3-107.55,26.62c-5.55-15.05-29.89-18.65-42.06,1.9 c-4.14-14.58-14.3-27.36-27.57-34.68c-13.27-7.33-28.84-9.77-43.39-5.51c3.16-15.37-2.88-31.37-12.03-44.12 c-9.15-12.75-21.24-23.02-32.26-34.19c-28.82-29.21-59.89-72.17-72.16-110.82c-16.2-51.03-21.14-104.31-25.54-157.59h-37.46 c-4.4,53.29-9.34,106.56-25.54,157.59c-12.27,38.65-43.34,81.61-72.16,110.82c-11.02,11.17-23.11,21.44-32.26,34.19 s-15.19,28.75-12.03,44.12c-14.55-4.26-30.12-1.82-43.39,5.51c-13.27,7.33-23.42,20.1-27.57,34.68 c-12.16-20.55-36.5-16.95-42.06-1.9c-31.6-20.32-70.84-34.6-107.55-26.62c-36.71,7.98-69.91,31.02-90.22,62.62 c-4.69-5.77-11.74-7.19-19.17-6.94c-7.43,0.25-14.65,4.13-18.95,10.19c-7.93-25.76-30.38-49.96-56.23-57.56 c-25.86-7.61-55.35-1.41-75.97,15.95c-6.85-19.93-31.02-33.06-51.37-27.58c-14.86-32.68-45.24-62.54-78.65-75.69 c-33.41-13.15-71.92-12.79-105.07,0.99c-1.18-18.44-13.71-35.42-30.04-44.07c-16.33-8.64-37.13-8.16-53.04,1.23v200.52H1920z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145765088982260177930000001492713935725887381_",
    gradientUnits: "userSpaceOnUse",
    x1: 3164.6899,
    y1: 727.3839,
    x2: 3164.6899,
    y2: 753.4954,
    gradientTransform: "matrix(-1 0 0 1 4214.4341 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5885,
    style: {
      stopColor: "#790043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#990043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8099,
    style: {
      stopColor: "#B00043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    style: {
      stopColor: "#BE0043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145765088982260177930000001492713935725887381_)"
    },
    d: "M1049.74,744.3h-21.07l2.91-24.56 c0.08-0.7,0.68-1.23,1.38-1.23h16.78h16.78c0.71,0,1.3,0.53,1.38,1.23l2.91,24.56H1049.74z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146498438212128234310000007500702733123561662_",
    gradientUnits: "userSpaceOnUse",
    x1: 3164.6899,
    y1: 719.4678,
    x2: 3164.6899,
    y2: 729.5964,
    gradientTransform: "matrix(-1 0 0 1 4214.4341 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146498438212128234310000007500702733123561662_)"
    },
    d: "M1070.65,736.33h-20.91h-20.91 c-0.76,0-1.34-0.69-1.2-1.44l0.32-1.78c0.1-0.58,0.61-1.01,1.2-1.01h20.59h20.59c0.59,0,1.1,0.42,1.2,1.01l0.32,1.78 C1071.99,735.64,1071.41,736.33,1070.65,736.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065063820224758413400000010122835815810961804_",
    gradientUnits: "userSpaceOnUse",
    x1: 3164.6899,
    y1: 719.468,
    x2: 3164.6899,
    y2: 729.5964,
    gradientTransform: "matrix(-1 0 0 1 4214.4341 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065063820224758413400000010122835815810961804_)"
    },
    d: "M1069.39,727.42h-19.64h-19.64 c-0.76,0-1.34-0.69-1.2-1.44l0.32-1.78c0.1-0.58,0.61-1.01,1.2-1.01h19.32h19.33c0.59,0,1.1,0.42,1.2,1.01l0.32,1.78 C1070.72,726.73,1070.15,727.42,1069.39,727.42z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132080794667458340050000012096306086948913556_",
    gradientUnits: "userSpaceOnUse",
    x1: 3193.3599,
    y1: 688.6973,
    x2: 3231.9358,
    y2: 694.8695,
    gradientTransform: "matrix(-1 0 0 1 4214.4341 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#630043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    style: {
      stopColor: "#810043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#B10043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132080794667458340050000012096306086948913556_)"
    },
    d: "M1013.65,653.11 c2,17.37-12.59,57.42-12.59,57.42l-12.67,9.34l1.07,5.35h33.27l-2.22-61.09L1013.65,653.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044868249528400805220000001149512385578146176_",
    gradientUnits: "userSpaceOnUse",
    x1: 3131.8501,
    y1: 689.5097,
    x2: 3097.9033,
    y2: 698.7679,
    gradientTransform: "matrix(-1 0 0 1 4214.4341 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#630043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    style: {
      stopColor: "#810043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#B10043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044868249528400805220000001149512385578146176_)"
    },
    d: "M1085.84,653.11 c-2,17.37,12.59,57.42,12.59,57.42l12.67,9.34l-1.07,5.35h-33.27l2.22-61.09L1085.84,653.11z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1001,456.32c1.12-112.09,48.74-152.55,48.74-152.55s47.62,40.46,48.74,152.55 c1.12,112.09-21.73,268.89-21.73,268.89h-27.01h-27.01C1022.73,725.21,999.88,568.41,1001,456.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051364430894173324090000016170011098236905880_",
    gradientUnits: "userSpaceOnUse",
    x1: 3164.6899,
    y1: 777.17,
    x2: 3164.6899,
    y2: 696.3569,
    gradientTransform: "matrix(-1 0 0 1 4214.4341 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#630043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    style: {
      stopColor: "#810043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#B10043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000051364430894173324090000016170011098236905880_)"
    },
    points: "1037.93,719.9 1043.73,711.89  1049.74,655.22 1055.76,711.89 1061.56,719.9 1062.58,725.21 1049.74,725.21 1036.91,725.21  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1073.42,392.79c0,0.79-0.64,1.43-1.43,1.43c-0.79,0-1.43-0.64-1.43-1.43c0-0.79,0.64-1.43,1.43-1.43 C1072.79,391.36,1073.42,392,1073.42,392.79z M1072,400.63c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S1072.79,400.63,1072,400.63z M1072,409.89c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S1072.79,409.89,1072,409.89z M1072,419.16c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C1073.42,419.8,1072.79,419.16,1072,419.16z M1072,428.42c-0.79,0-1.43,0.64-1.43,1.43 c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C1073.42,429.06,1072.79,428.42,1072,428.42z M1072,437.69 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,437.69,1072,437.69z M1072,446.95 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,446.95,1072,446.95z M1072,456.22 c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C1073.42,456.86,1072.79,456.22,1072,456.22 z M1072,465.49c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,465.49,1072,465.49z  M1072,474.75c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,474.75,1072,474.75z  M1072,484.02c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43 C1073.42,484.66,1072.79,484.02,1072,484.02z M1072,493.28c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S1072.79,493.28,1072,493.28z M1072,502.55c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S1072.79,502.55,1072,502.55z M1072,511.81c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S1072.79,511.81,1072,511.81z M1072,521.08c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C1073.42,521.72,1072.79,521.08,1072,521.08z M1072,530.35c-0.79,0-1.43,0.64-1.43,1.43 s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,530.35,1072,530.35z M1072,539.61c-0.79,0-1.43,0.64-1.43,1.43 s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,539.61,1072,539.61z M1072,548.88c-0.79,0-1.43,0.64-1.43,1.43 c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C1073.42,549.51,1072.79,548.88,1072,548.88z M1072,558.14 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,558.14,1072,558.14z M1072,567.41 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,567.41,1072,567.41z M1072,576.67 c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C1073.42,577.31,1072.79,576.67,1072,576.67 z M1072,585.94c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,585.94,1072,585.94z  M1072,595.2c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,595.2,1072,595.2z  M1072,604.47c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,604.47,1072,604.47z  M1072,613.74c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43 C1073.42,614.37,1072.79,613.74,1072,613.74z M1072,623c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S1072.79,623,1072,623z M1072,632.27c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S1072.79,632.27,1072,632.27z M1072,641.53c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C1073.42,642.17,1072.79,641.53,1072,641.53z M1072,650.8c-0.79,0-1.43,0.64-1.43,1.43 s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,650.8,1072,650.8z M1072,660.06c-0.79,0-1.43,0.64-1.43,1.43 s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,660.06,1072,660.06z M1072,669.33c-0.79,0-1.43,0.64-1.43,1.43 c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C1073.42,669.97,1072.79,669.33,1072,669.33z M1072,678.6 c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C1073.42,679.23,1072.79,678.6,1072,678.6z  M1072,687.86c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,687.86,1072,687.86z  M1072,697.13c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S1072.79,697.13,1072,697.13z  M1072,706.39c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43 C1073.42,707.03,1072.79,706.39,1072,706.39z M1072,715.66c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S1072.79,715.66,1072,715.66z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1010.96,630.34c48.87,0,105.75,0,105.75,0s5.73-36.7-14.84-62.62c-20.57-25.93-79.26-72.03-74.26-142.36 c5-70.33-67.62,204.98-67.62,204.98H1010.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053534391832447887900000006463278767874198965_",
    gradientUnits: "userSpaceOnUse",
    x1: 870.2556,
    y1: 727.3839,
    x2: 870.2556,
    y2: 753.4954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5885,
    style: {
      stopColor: "#790043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#990043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8099,
    style: {
      stopColor: "#B00043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    style: {
      stopColor: "#BE0043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053534391832447887900000006463278767874198965_)"
    },
    d: "M870.26,744.3h21.07l-2.91-24.56 c-0.08-0.7-0.68-1.23-1.38-1.23h-16.78h-16.78c-0.71,0-1.3,0.53-1.38,1.23l-2.91,24.56H870.26z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002374704811692099880000013512454173020936375_",
    gradientUnits: "userSpaceOnUse",
    x1: 870.2556,
    y1: 719.4678,
    x2: 870.2556,
    y2: 729.5964
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002374704811692099880000013512454173020936375_)"
    },
    d: "M849.35,736.33h20.91h20.91 c0.76,0,1.34-0.69,1.2-1.44l-0.32-1.78c-0.1-0.58-0.61-1.01-1.2-1.01h-20.59h-20.59c-0.59,0-1.1,0.42-1.2,1.01l-0.32,1.78 C848.01,735.64,848.59,736.33,849.35,736.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105422628652313303230000000635850777470091406_",
    gradientUnits: "userSpaceOnUse",
    x1: 870.2556,
    y1: 719.468,
    x2: 870.2556,
    y2: 729.5964
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105422628652313303230000000635850777470091406_)"
    },
    d: "M850.61,727.42h19.64h19.64 c0.76,0,1.34-0.69,1.2-1.44l-0.32-1.78c-0.1-0.58-0.61-1.01-1.2-1.01h-19.33h-19.33c-0.59,0-1.1,0.42-1.2,1.01l-0.32,1.78 C849.28,726.73,849.85,727.42,850.61,727.42z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142178564027829632910000007556896916677914254_",
    gradientUnits: "userSpaceOnUse",
    x1: 898.9255,
    y1: 688.6973,
    x2: 937.5016,
    y2: 694.8695
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#630043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    style: {
      stopColor: "#810043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#B10043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142178564027829632910000007556896916677914254_)"
    },
    d: "M906.35,653.11 c-2,17.37,12.59,57.42,12.59,57.42l12.67,9.34l-1.07,5.35h-33.27l2.22-61.09L906.35,653.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149379989537333413170000007510167694573162149_",
    gradientUnits: "userSpaceOnUse",
    x1: 837.4158,
    y1: 689.5097,
    x2: 803.4688,
    y2: 698.768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#630043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    style: {
      stopColor: "#810043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#B10043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149379989537333413170000007510167694573162149_)"
    },
    d: "M834.16,653.11 c2,17.37-12.59,57.42-12.59,57.42l-12.67,9.34l1.07,5.35h33.27l-2.22-61.09L834.16,653.11z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M919,456.32c-1.12-112.09-48.74-152.55-48.74-152.55s-47.62,40.46-48.74,152.55 c-1.12,112.09,21.73,268.89,21.73,268.89h27.01h27.01C897.27,725.21,920.12,568.41,919,456.32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M828.92,388.18h82.67c-0.31-1.39-0.63-2.76-0.96-4.12h-80.76C829.55,385.42,829.23,386.79,828.92,388.18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1091.08,388.18h-82.67c0.31-1.39,0.63-2.76,0.96-4.12h80.76C1090.45,385.42,1090.77,386.79,1091.08,388.18 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128485178813981488470000009267347817401978768_",
    gradientUnits: "userSpaceOnUse",
    x1: 870.2556,
    y1: 777.17,
    x2: 870.2556,
    y2: 696.3569
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#630043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    style: {
      stopColor: "#810043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    style: {
      stopColor: "#B10043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000128485178813981488470000009267347817401978768_)"
    },
    points: "882.07,719.9 876.27,711.89  870.26,655.22 864.24,711.89 858.44,719.9 857.42,725.21 870.26,725.21 883.09,725.21  "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M849.55,392.79c0,0.79-0.64,1.43-1.43,1.43c-0.79,0-1.43-0.64-1.43-1.43c0-0.79,0.64-1.43,1.43-1.43 C848.91,391.36,849.55,392,849.55,392.79z M848.13,400.63c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S848.91,400.63,848.13,400.63z M848.13,409.89c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S848.91,409.89,848.13,409.89z M848.13,419.16c-0.79,0-1.43,0.64-1.43,1.43 c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C849.55,419.8,848.91,419.16,848.13,419.16z M848.13,428.42 c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C849.55,429.06,848.91,428.42,848.13,428.42 z M848.13,437.69c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,437.69,848.13,437.69z  M848.13,446.95c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,446.95,848.13,446.95z  M848.13,456.22c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43 C849.55,456.86,848.91,456.22,848.13,456.22z M848.13,465.49c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S848.91,465.49,848.13,465.49z M848.13,474.75c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S848.91,474.75,848.13,474.75z M848.13,484.02c-0.79,0-1.43,0.64-1.43,1.43 c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C849.55,484.66,848.91,484.02,848.13,484.02z M848.13,493.28 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,493.28,848.13,493.28z M848.13,502.55 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,502.55,848.13,502.55z M848.13,511.81 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,511.81,848.13,511.81z M848.13,521.08 c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C849.55,521.72,848.91,521.08,848.13,521.08 z M848.13,530.35c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,530.35,848.13,530.35z  M848.13,539.61c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,539.61,848.13,539.61z  M848.13,548.88c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43 C849.55,549.51,848.91,548.88,848.13,548.88z M848.13,558.14c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S848.91,558.14,848.13,558.14z M848.13,567.41c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S848.91,567.41,848.13,567.41z M848.13,576.67c-0.79,0-1.43,0.64-1.43,1.43 c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C849.55,577.31,848.91,576.67,848.13,576.67z M848.13,585.94 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,585.94,848.13,585.94z M848.13,595.2 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,595.2,848.13,595.2z M848.13,604.47 c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,604.47,848.13,604.47z M848.13,613.74 c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C849.55,614.37,848.91,613.74,848.13,613.74 z M848.13,623c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,623,848.13,623z  M848.13,632.27c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,632.27,848.13,632.27z  M848.13,641.53c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43 C849.55,642.17,848.91,641.53,848.13,641.53z M848.13,650.8c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S848.91,650.8,848.13,650.8z M848.13,660.06c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S848.91,660.06,848.13,660.06z M848.13,669.33c-0.79,0-1.43,0.64-1.43,1.43 c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C849.55,669.97,848.91,669.33,848.13,669.33z M848.13,678.6 c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43C849.55,679.23,848.91,678.6,848.13,678.6z  M848.13,687.86c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,687.86,848.13,687.86z  M848.13,697.13c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43S848.91,697.13,848.13,697.13z  M848.13,706.39c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43 C849.55,707.03,848.91,706.39,848.13,706.39z M848.13,715.66c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43S848.91,715.66,848.13,715.66z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M909.04,630.34c-48.87,0-105.75,0-105.75,0s-5.73-36.7,14.84-62.62c20.57-25.93,79.26-72.03,74.26-142.36 c-5-70.33,67.62,204.98,67.62,204.98H909.04z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M906.81,605.11h106.37c0.16-1.75,0.31-3.52,0.47-5.32H906.34C906.5,601.59,906.66,603.36,906.81,605.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M907.29,610.43h105.43c0.15-1.75,0.31-3.52,0.47-5.32H906.81C906.97,606.91,907.13,608.68,907.29,610.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023260360924162395230000008632426728986706331_",
    gradientUnits: "userSpaceOnUse",
    x1: 3255.3503,
    y1: 641.8342,
    x2: 3255.3503,
    y2: 691.4205,
    gradientTransform: "matrix(-1 0 0 1 4214.4341 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5885,
    style: {
      stopColor: "#790043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#990043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8099,
    style: {
      stopColor: "#B00043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    style: {
      stopColor: "#BE0043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023260360924162395230000008632426728986706331_)"
    },
    d: "M959.08,673.95h-40l5.52-46.64 c0.16-1.33,1.28-2.33,2.62-2.33h31.86h31.86c1.34,0,2.47,1,2.62,2.33l5.52,46.64H959.08z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154407176508759495450000017288384079640184236_",
    gradientUnits: "userSpaceOnUse",
    x1: 3255.3503,
    y1: 626.8022,
    x2: 3255.3503,
    y2: 646.0363,
    gradientTransform: "matrix(-1 0 0 1 4214.4341 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154407176508759495450000017288384079640184236_)"
    },
    d: "M998.78,658.81h-39.7h-39.7 c-1.44,0-2.54-1.31-2.28-2.73l0.6-3.38c0.2-1.11,1.16-1.91,2.28-1.91h39.1h39.1c1.12,0,2.09,0.81,2.28,1.91l0.6,3.38 C1001.32,657.51,1000.23,658.81,998.78,658.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047047591621966727290000009017923456645979777_",
    gradientUnits: "userSpaceOnUse",
    x1: 3255.3503,
    y1: 626.8015,
    x2: 3255.3503,
    y2: 646.0364,
    gradientTransform: "matrix(-1 0 0 1 4214.4341 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047047591621966727290000009017923456645979777_)"
    },
    d: "M996.39,641.91h-37.3h-37.3 c-1.44,0-2.54-1.31-2.28-2.73l0.6-3.38c0.2-1.11,1.16-1.91,2.28-1.91h36.7h36.7c1.12,0,2.09,0.81,2.28,1.91l0.6,3.38 C998.92,640.6,997.83,641.91,996.39,641.91z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M894.56,273.47C906.41,195.29,960,160.28,960,160.28s53.59,35,65.44,113.19s-6.75,267.69-14.48,356.86H960 h-50.96C901.3,541.16,882.71,351.66,894.56,273.47z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M960,203.27L960,203.27L960,203.27L960,203.27L960,203.27c-14.48,0-42.7,29.9-40.85,37.42 c0.59,2.41,3.32,2.49,7.29,1.37c21.91-6.18,45.21-6.18,67.13,0c3.97,1.12,6.69,1.04,7.29-1.37 C1002.7,233.17,974.48,203.27,960,203.27z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M923.1,238.88c0.8-2.33,3.9-7.64,10.98-14.95c9.61-9.92,20.26-16.85,25.92-16.85 c5.66,0,16.31,6.93,25.92,16.85c7.08,7.31,10.18,12.62,10.98,14.95c-0.53-0.07-1.27-0.21-2.3-0.5 c-11.24-3.17-22.88-4.78-34.6-4.78c-11.72,0-23.36,1.61-34.6,4.78C924.37,238.67,923.63,238.82,923.1,238.88z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M947.06,232.36c-4.72,0.48-9.42,1.21-14.06,2.2l25.35-25.35c0.6-0.13,1.16-0.21,1.64-0.21 c1.8,0,4.53,0.96,7.83,2.81C960.91,218.66,953.98,225.5,947.06,232.36z M986.95,227.82c-0.73-0.81-1.53-1.67-2.4-2.56 c-1.09-1.13-2.18-2.19-3.25-3.2l-10.13,10.13c3.4,0.29,6.78,0.72,10.13,1.28C983.18,231.59,985.06,229.7,986.95,227.82z  M962.63,231.74c4.63-4.63,9.26-9.26,13.89-13.89c-0.66-0.54-1.31-1.06-1.95-1.55c-5.17,5.13-10.31,10.3-15.52,15.41 c0.32,0,0.63-0.01,0.95-0.01C960.88,231.7,961.75,231.72,962.63,231.74z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M948.82,174.16c-0.63,0-1.15,0.51-1.15,1.15s0.51,1.15,1.15,1.15s1.15-0.51,1.15-1.15 S949.45,174.16,948.82,174.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M956.27,174.16c-0.63,0-1.15,0.51-1.15,1.15s0.51,1.15,1.15,1.15c0.63,0,1.15-0.51,1.15-1.15 S956.91,174.16,956.27,174.16z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st30",
    cx: 963.73,
    cy: 175.3,
    r: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M971.18,174.16c-0.63,0-1.15,0.51-1.15,1.15s0.51,1.15,1.15,1.15c0.63,0,1.15-0.51,1.15-1.15 S971.82,174.16,971.18,174.16z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M899.14,371.15L899.14,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C900.54,370.52,899.91,371.15,899.14,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M909.63,371.15H908c-0.33,0-0.59-0.26-0.59-0.59v-5.61c0-0.33,0.26-0.59,0.59-0.59h1.63 c0.33,0,0.59,0.26,0.59,0.59v5.61C910.22,370.89,909.96,371.15,909.63,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M918.49,371.15L918.49,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C919.9,370.52,919.27,371.15,918.49,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M928.17,371.15L928.17,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C929.57,370.52,928.95,371.15,928.17,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M937.85,371.15L937.85,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C939.25,370.52,938.62,371.15,937.85,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M947.52,371.15L947.52,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C948.93,370.52,948.3,371.15,947.52,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M957.2,371.15L957.2,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C958.61,370.52,957.98,371.15,957.2,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M966.88,371.15L966.88,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C968.28,370.52,967.65,371.15,966.88,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M976.56,371.15L976.56,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C977.96,370.52,977.33,371.15,976.56,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M986.23,371.15L986.23,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C987.64,370.52,987.01,371.15,986.23,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M995.91,371.15L995.91,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C997.32,370.52,996.69,371.15,995.91,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1005.59,371.15L1005.59,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C1006.99,370.52,1006.36,371.15,1005.59,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1015.26,371.15L1015.26,371.15c-0.78,0-1.41-0.63-1.41-1.41v-3.98c0-0.78,0.63-1.41,1.41-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C1016.67,370.52,1016.04,371.15,1015.26,371.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1024.94,371.15L1024.94,371.15c-0.78,0-1.4-0.63-1.4-1.41v-3.98c0-0.78,0.63-1.41,1.4-1.41l0,0 c0.78,0,1.41,0.63,1.41,1.41v3.98C1026.35,370.52,1025.72,371.15,1024.94,371.15z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M995.93,447.97c0,0.79-0.64,1.43-1.43,1.43s-1.43-0.64-1.43-1.43c0-0.79,0.64-1.43,1.43-1.43 S995.93,447.18,995.93,447.97z M994.5,455.81c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43 S995.29,455.81,994.5,455.81z M994.5,465.07c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43 S995.29,465.07,994.5,465.07z M994.5,474.34c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43 C995.93,474.97,995.29,474.34,994.5,474.34z M994.5,483.6c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43 S995.29,483.6,994.5,483.6z M994.5,492.87c-0.79,0-1.43,0.64-1.43,1.43s0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43 S995.29,492.87,994.5,492.87z M994.5,502.13c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43 C995.93,502.77,995.29,502.13,994.5,502.13z M994.5,511.4c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 s1.43-0.64,1.43-1.43C995.93,512.04,995.29,511.4,994.5,511.4z M994.5,520.66c-0.79,0-1.43,0.64-1.43,1.43 c0,0.79,0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43C995.93,521.3,995.29,520.66,994.5,520.66z M994.5,529.93 c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43C995.93,530.57,995.29,529.93,994.5,529.93z  M994.5,539.2c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43s1.43-0.64,1.43-1.43 C995.93,539.83,995.29,539.2,994.5,539.2z M994.5,548.46c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 s1.43-0.64,1.43-1.43C995.93,549.1,995.29,548.46,994.5,548.46z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M1028.78,377.13c-0.01,0.4-0.02,0.79-0.03,1.19H899.73c0.1,65.92,17.16,235.46,18.24,246.06h93.51 c-0.03,0.39-0.07,0.8-0.1,1.19H908.62c-0.03-0.39-0.07-0.79-0.1-1.19h8.26c-1.2-11.89-18.13-180.36-18.23-246.06h-7.29 c-0.01-0.4-0.02-0.79-0.03-1.19H1028.78z M1025.94,441.14c0.02-0.4,0.04-0.79,0.07-1.19H988.4c-0.33,0-0.59,0.27-0.59,0.59v116.77 c0,0.33,0.27,0.59,0.59,0.59h28.91c0.03-0.4,0.07-0.79,0.1-1.19h-28.42V441.14H1025.94z M961.07,274.68 c0.33,0,0.59-0.27,0.59-0.59v-7.1c0-0.06-0.05-0.1-0.07-0.16h55.07h7.64c-0.07-0.4-0.15-0.79-0.23-1.19h-6.9 c-4.98-33.2-18.64-61.38-41.69-86.09h5.92c-0.36-0.4-0.73-0.81-1.08-1.19h-40.65c-0.36,0.38-0.72,0.79-1.08,1.19h35.29 c23.3,24.68,37.07,52.85,42.09,86.09H895.92c-0.08,0.4-0.15,0.79-0.23,1.19h64.85c-0.02,0.06-0.07,0.1-0.07,0.16v6.5h-65.92 c-0.06,0.39-0.11,0.8-0.17,1.19H961.07z"
  })), /*#__PURE__*/React.createElement("g", null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M820.88,630.34c0.38,0,0.79,0,1.19,0V563c-0.41,0.47-0.8,0.93-1.19,1.38V630.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174594427057279464410000014501283931949380273_",
    gradientUnits: "userSpaceOnUse",
    x1: 830.0868,
    y1: 551.2263,
    x2: 886.2693,
    y2: 551.2263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0304,
    style: {
      stopColor: "#770043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#580043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6185,
    style: {
      stopColor: "#630043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7575,
    style: {
      stopColor: "#810043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9394,
    style: {
      stopColor: "#B10043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C30043"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174594427057279464410000014501283931949380273_)"
    },
    d: "M870.85,630.34v-6.5h-39.57V576.9 l54.84-61.84l0.15-0.17v-42.77c-0.38,1.13-0.78,2.26-1.19,3.37v38.95l-53.8,60.67v-22.24c-0.4,0.43-0.8,0.86-1.19,1.28v22.52 v1.57v52.1c0.39,0,0.79,0,1.19,0v-5.31h38.39v5.31C870.06,630.34,870.45,630.34,870.85,630.34z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1099.12,630.34c-0.38,0-0.79,0-1.19,0V563c0.41,0.47,0.8,0.93,1.19,1.38V630.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1049.15,630.34v-6.5h39.57V576.9l-54.84-61.84l-0.15-0.17v-42.77c0.38,1.13,0.78,2.26,1.19,3.37v38.95 l53.8,60.67v-22.24c0.4,0.43,0.8,0.86,1.19,1.28v22.52v1.57v52.1c-0.39,0-0.79,0-1.19,0v-5.31h-38.39v5.31 C1049.94,630.34,1049.55,630.34,1049.15,630.34z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleto);
export default __webpack_public_path__ + "static/media/completo.db2a8736d3dee5d3c2583a26eb3d90b7.svg";
export { ForwardRef as ReactComponent };